<template>
  <div class="row">
    <div class="col-md-12">
      <p>
        <Adsense :data-ad-client="client" :data-ad-slot="slot"></Adsense>
      </p>
    </div>
  </div>
</template>

<script>

  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';
  import $ from 'jquery';

  export default {
    name: "Test",
    props: ['slotp', 'clientp'],
    components: {
      Loading
    },
    data() {
      return {
        showContent: false,
        html: '',
        title: '',
        classemodule: '',
        id: '',
        client: this.clientp,
        slot: this.slotp,
      }
    },
    mounted() {
    },
    created() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/home/Test.vue